<template>
    <footer>
        <el-row type="flex" justify="center" :gutter="15">
            <el-col :xs="{span: 22, pull: 1}" :span="7" class="name-and-logo-col">
                <img src="../assets/images/AuthPageLogo.png" />
                گروه علمی آموزشی اوج
            </el-col>

            <el-col :xs="{span: 22, pull: 1}" :span="7" class="links-col">
                <span>لینک ها</span>
                <ul>
                    <li>
                        <router-link to="/">خانه</router-link>
                    </li>
                    <li>
                        <router-link to="/posts">اخبار و مطالب</router-link>
                    </li>
                    <li>
                        <router-link to="/courses">دروس</router-link>
                    </li>
                    <li>
                        <router-link to="/contact-us">تماس با ما</router-link>
                    </li>
                    <li>
                        <router-link to="/about-us">درباره ما</router-link>
                    </li>
                    <li>
                        <router-link to="/terms">قوانین</router-link>
                    </li>
                </ul>
            </el-col>

            <el-col :xs="{span: 22, pull: 1}" :span="7" class="social-media-col">
                اوج در شبکه های اجتماعی
                <div class="social-media-icons-container">
                    <a target="_blank" href="https://t.me/OwjEdu_ir"><app-telegram-icon/></a>
                    <a target="_blank" href=""><app-instagram-icon/></a>
                    <a target="_blank" href=""><app-linkedin-icon/></a>
                    <a target="_blank" href=""><app-twitter-icon/></a>
                    <a target="_blank" href=""><app-facebook-icon/></a>
                </div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="copy-right-row">
            <el-col :span="22" :push="1">
                <span>©</span>
                تمامی حقوق این وب سایت متعلق به
                <span>گروه علمی-آموزشی اوج</span>
                می‌باشد.
            </el-col>
        </el-row>
    </footer>
</template>

<script>
    export default {
        name: 'AppFooter'
    }
</script>

<style lang="scss" scoped>
    footer {
        background-color: #337AB7;
        color: white;
        margin-top: 50px;

        .el-row {
            margin: 0 !important;
            padding: 30px 0 0;
            direction: rtl;
            @media only screen and (max-width: 767px) {
                flex-direction: column;
            }

            .el-col {
                @media only screen and (max-width: 767px) {
                    margin-bottom: 30px;
                }

                &.name-and-logo-col {
                    font-size: 25px;

                    img {
                        display: block;
                        max-width: 100px;
                        margin: 0 auto;
                    }
                }

                &.links-col {
                    text-align: right;
                    font-weight: bold;
                    font-size: 18px;
                    padding-right: 5% !important;
                    @media only screen and (max-width: 767px) {
                        padding-right: 0 !important;
                    }

                    span {
                        position: relative;
                        right: 20px;
                    }

                    ul {
                        li {
                            text-align: right;
                            font-weight: normal;
                            font-size: 15px;

                            a {
                                text-decoration: none;
                                color: white;
                                outline: none;
                            }
                        }
                    }
                }

                &.social-media-col {
                    text-align: right;
                    font-weight: bold;
                    font-size: 18px;

                    .social-media-icons-container {
                        max-width: 350px;
                        margin-top: 40px;
                        display: flex;
                        justify-content: space-between;
                        @media only screen and (max-width: 767px) {
                            margin: 25px auto 0;
                        }

                        a {
                            text-decoration: none;
                            color: white;
                            outline: none;

                            svg {
                                height: 30px;
                            }
                        }
                    }
                }
            }



            &.copy-right-row {
                padding: 0 0 30px !important;

                .el-col {
                    span {
                        font-weight: bold;
                        font-style: italic;

                        &:first-child {
                            font-style: normal;
                        }
                    }
                }
            }
        }

        .el-divider {
            width: 70%;
            margin: 24px auto;
        }
    }
</style>
